import React from "react"
import GoBack from "./GoBack"

const NotFoundPage = () => {
  return (
    <>
      <h3>404 Error</h3>
      <p>Page Not Found</p>
      <GoBack />
    </>
  )
}

export default NotFoundPage